import { Box } from '@mui/material';
import { useAiChatStore } from '../store/aiChat.store';
import AiChatConversationThread from './AiChatConversationThread';
import AiChatLanding from './AiChatLanding';
import AiChatMessageInput from './AiChatMessageInput';
import { AiChatDebugPanel } from './debug';

export default function AiChatDrawerContent() {
  const conversationId = useAiChatStore((state) => state.conversationId);
  const debugModeEnabled = useAiChatStore((state) => state.debugModeEnabled);

  // Debug mode shows the debug panel instead of the chat view
  if (debugModeEnabled && conversationId) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', flexGrow: 1 }}>
        <AiChatDebugPanel />
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', flexGrow: 1 }}>
      {conversationId ? <AiChatConversationThread key={`conversation-${conversationId}`} /> : <AiChatLanding />}
      <AiChatMessageInput />
    </Box>
  );
}
